import { useMarketplace } from 'hooks';
import { isSettingEnabled } from 'utils/SettingsUtils';

export const useServiceCategories = (): {
    hasGrooming: boolean;
    hasMobileGrooming: boolean;
    hasDental: boolean;
    hasDaycare: boolean;
    hasBoarding: boolean;
    hasTransportation: boolean;
    hasTraining: boolean;
    hasEvaluation: boolean;
    hasWalking: boolean;
} => {
    const marketplace = useMarketplace();
    return {
        hasGrooming: isSettingEnabled(marketplace.settings, 'grooming_enabled'),
        hasMobileGrooming: isSettingEnabled(marketplace.settings, 'mobile_grooming_enabled'),
        hasDental: marketplace.businessAreas.some(ba => ba.id === 'dental'),
        hasDaycare: isSettingEnabled(marketplace.settings, 'daycare_enabled'),
        hasBoarding: isSettingEnabled(marketplace.settings, 'boarding_enabled'),
        hasTransportation: isSettingEnabled(marketplace.settings, 'transportation_enabled'),
        hasEvaluation: marketplace.evaluationEnabled,
        hasTraining: isSettingEnabled(marketplace.settings, 'training_enabled'),
        hasWalking: isSettingEnabled(marketplace.settings, 'walking_enabled')
    };
};

export default useServiceCategories;
